module.exports = __webpack_public_path__ + "img/1.a62162e0.jpg";